import Report from './Report'

export default {
  Report
}



// WEBPACK FOOTER //
// ./src/components/Mazda/index.js